export default __webpack_public_path__ + "static/media/sounds/maze_practice_intro_alyx.mp3";